// Refresh only participant regions so activity tabs and unsaved editors stay put.
export async function refreshParticipantLists(activityId, inloopId) {
  const keys = [`activity-${activityId}`, `inloop-${inloopId}`]
  const regions = [...document.querySelectorAll('[data-participant-list]')]
    .filter(element => keys.includes(element.dataset.participantList))
  if (regions.length === 0) return

  const url = window.location.href
  const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' })
  if (!response.ok || response.redirected) throw new Error('Could not refresh participants')
  const page = new DOMParser().parseFromString(await response.text(), 'text/html')
  const replacements = regions.map(element => {
    const replacement = [...page.querySelectorAll('[data-participant-list]')]
      .find(candidate => candidate.dataset.participantList === element.dataset.participantList)
    if (!replacement) throw new Error('Participant list missing from response')
    return [element, replacement]
  })
  if (window.location.href !== url) return
  for (const [element, replacement] of replacements) {
    if (element.isConnected) element.replaceWith(replacement)
  }
}
